// import SmoothScroll from './_SmoothScroll.js'
// import ScrollHelper from './_ScrollHelper.js'
import Intersection from './_Intersection.js'
import ReplaceSVG from './_ReplaceSVG.js'
// import ResizeHelper from './_ResizeHelper.js'
import ScrollDirectionClass from './_ScrollDirectionClass.js'
import anime from 'animejs/lib/anime.es.js'


const replaceSVG = new ReplaceSVG(e => {
  new Intersection('.js-steps', (entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('--inview')
        observer.unobserve(entry.target)
      }
    })
  }, {
    addclass: '--inview',
    root: null,
    rootMargin: "0% 0px -10% 0px",
    threshold: 0,
  })
})

$(async (_) => {

  // anime({
  //   targets: '.p-kv',
  //   // delay: 400,
  //   opacity: [0, 1],
  //   duration: 400,
  //   // translateY: [-20, 0],
  //   // easing: 'linear'
  // })

  // anime({
  //   targets: '.p-sus-title.--fade',
  //   // delay: 400,
  //   opacity: {
  //     value: [0, 1],
  //     duration: 1800,
  //     delay: 600,
  //   },
  // })
  // const l_sus_mainStyle = window.getComputedStyle(document.querySelector('.l-sus-main'))
  // if(l_sus_mainStyle.opacity === '0' || l_sus_mainStyle.opacity === 0) {
  //   anime({
  //     targets: '.l-sus-main',
  //     // delay: 400,
  //     opacity: {
  //       value: [0, 1],
  //       duration: 1800,
  //       // delay: 200,
  //       delay: 600,
  //     }
  //   })
  // }
  // anime({
  //   targets: '.c-background.--fade',
  //   // delay: 400,
  //   opacity: {
  //     value: [0, 1],
  //     duration: 3200,
  //     // delay: 200,
  //     delay: 600,
  //   },
  //   // borderTop: {
  //   //   value: [48, -0],
  //   //   easing: 'easeOutExpo',
  //   //   duration: 1800,
  //   //   delay: 600,
  //   // }
  // })
  anime({
    targets: '.p-scroll',
    opacity: [0, 1],
    duration: 400,
    delay: 2800,
    easing: 'linear',
    complete: () => {

      anime({
        targets: '.anim--scroll path',
        opacity: [1, 0],
        duration: 10,
        direction: 'reverse',
        loop: true,
        delay: anime.stagger(140, {start: 1700}) // delay 
      });
    }
  });

  anime({
    targets: '.anim--banner',
    opacity: [0, 1],
    duration: 400,
    delay: 2400,
    easing: 'linear',
  });

  anime({
    targets: '.anim--logo',
    // delay: 400,
    opacity: {
      value: [0, 1],
      duration: 600,
      delay: 400,
    },
    scale: {
      value: [0.98, 1],
      duration: 600,
      delay: 400,
    },
    translateY: {
      value: [-40, 0],
      easing: 'easeOutElastic(1, .25)',
      duration: 2000,
      delay: 400,
    }
  })
  setTimeout( _ => {

    document.querySelectorAll('.anim--onload').forEach(el => {
      const delay = parseInt(el.dataset.delay || 0)
      setTimeout(e => {
        el.classList.add('--animate')
      }, delay)
    })

  }, 700)

replaceSVG.replace()

  new ScrollDirectionClass()
  // inview
  new Intersection('.js-inview', entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-inview')
        // intersection.destroy()
      }
    })
  }, {
    root: null,
    rootMargin: "-10% 0px -20% 0px",
    threshold: 0
  })

  // const subtitleObserver = new Intersection('.anim--subtitle', entries => {
  //   entries.forEach(entry => {
  //     if (entry.isIntersecting) {
  //       // entry.target.classList.add('is-inview')
  //       // intersection.destroy()
  //       anime({
  //         targets: entry.target,
  //         // delay: 400,
  //         opacity: {
  //           value: [0, 1],
  //           duration: 600,
  //           // delay: 200,
  //         },
  //         scale: {
  //           value: [0.95, 1],
  //           easing: 'easeOutElastic(1, .25)',
  //           duration: 900,
  //           // delay: 200,
  //         },
  //       })
  //       subtitleObserver.unobserve(entry.target);
  //     }
  //   })
  // }, {
  //   root: null,
  //   rootMargin: "-10% 0px -20% 0px",
  //   threshold: 0
  // })

})
